import React, { useContext, useState } from "react";
import CommissaryEmployeeLayout from "../../layout/CommissaryEmployeeLayout";
import axios from "axios";
import { Button, Input, Modal, Table, Tooltip } from "antd";
import { NotificationInfo, PermissionInfo, UserInfo } from "../../../context";
import moment from "moment";
import { AuditOutlined, CheckCircleOutlined } from "@ant-design/icons";
import PODetails from "./PODetails";

const Delivery = () => {
  const [loading, setLoading] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [selectedData, setSelectedData] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [acknowledgeDialog, setAcknowledgeDialog] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [search, setSearch] = useState("");
  const { poList, render } = useContext(PermissionInfo);

  const columns = [
    {
      title: "Date Created",
      dataIndex: "created_at",
      sorter: (a, b) => a.created_at - b.created_at,
      render: (date) => (
        <p>{moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Merchant PO Number",
      dataIndex: "po_number",
      sorter: (a, b) => a.po_number - b.po_number,
      render: (text, record) => (
        <p
          style={{
            color: "blue",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Merchant",
      render: (text, record) => <p>{text.posavemerchantinfo.business_name}</p>,
    },

    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p style={{ width: window.innerWidth < 733 ? 80 : "auto" }}>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
            />
          </Tooltip>

          <Tooltip title="Acknowledge">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setAcknowledgeDialog(true);
              }}
              icon={<CheckCircleOutlined />}
              style={{ marginLeft: 10 }}
            />
          </Tooltip>
        </p>
      ),
    },
  ];
  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const searchable = poList.data.filter((data) => {
    return (
      data.po_number.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.posavemerchantinfo.business_name
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setAcknowledgeDialog(false);
      setConfirmLoading(false);
      handleAcknowledgePO();
    }, 2000);
  };

  const handleAcknowledgePO = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "po_number_id",
      selectedData !== null ? selectedData.po_number_id : ""
    );
    setLoading(true);
    axios
      .post("user/commissary-employee/acknowledge-po", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Acknowledge purchase order successfully.");
          setTimeout(() => {
            setLoading(false);
            render();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        setLoading(false);
      });
  };

  return (
    <CommissaryEmployeeLayout>
      <div style={{ marginBottom: 10 }}>
        <Input
          placeholder="Search P.O # or business name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            border: "2px solid #e5e5e5",
            width: window.innerWidth < 576 ? "100%" : 300,
          }}
          size="large"
        />
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.po_number_id}
        />
      </div>

      {openDrawer && (
        <PODetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
        />
      )}

      <Modal
        title="Are you sure to acknowledge this purchase order?"
        open={acknowledgeDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setAcknowledgeDialog(false)}
      />
    </CommissaryEmployeeLayout>
  );
};

export default Delivery;
